export default __webpack_public_path__ + "static/media/glitch16.276ff7af.png";